export default function TypeZipCode({ value }) {
  return <div>{value}</div>
}
